import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import { performCreateChapters } from '@/utils/courseStudio/chapter';
import { performUpdateLessonChapters } from '@/utils/courseStudio/chapter';

async function performCreateChaptersIntoLessons(newBlocks: TempLessonBlock[]) {
  const createdBlocks: TempLessonBlock[] = [];

  for (const block of newBlocks) {
    const createdLessons = await performCreateChapters(block.lessons);

    createdBlocks.push({ ...block, lessons: createdLessons });
  }

  return createdBlocks;
}

async function performUpdateChaptersIntoLessons(
  currentBlocks: TempLessonBlock[],
  newBlocks: TempLessonBlock[],
): Promise<TempLessonBlock[]> {
  const updatedBlocks: TempLessonBlock[] = [];

  for (const newBlock of newBlocks) {
    const currentBlock = currentBlocks.find(b => b.id === newBlock.id);

    const updatedLessons = await performUpdateLessonChapters(
      currentBlock?.lessons || [],
      newBlock.lessons,
    );

    updatedBlocks.push({
      ...newBlock,
      lessons: updatedLessons,
    });
  }

  return updatedBlocks;
}

export function useCourseStudioChapters() {
  async function handleCreateChapters(newBlocks: TempLessonBlock[]) {
    const createdBlocksWithChapters = await performCreateChaptersIntoLessons(
      newBlocks,
    );

    return createdBlocksWithChapters;
  }

  async function handleUpdateChapters(
    currentBlocks: TempLessonBlock[],
    newBlocks: TempLessonBlock[],
  ) {
    const updatedBlocks = await performUpdateChaptersIntoLessons(
      currentBlocks,
      newBlocks,
    );

    return updatedBlocks;
  }

  return {
    handleCreateChapters,
    handleUpdateChapters,
  };
}
